import { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";

import { api } from "../lib/api";
import { Button } from "./ui/button";

/** Self-serve data export — their records, on demand, without asking us. */
export const DataExportCard = () => {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get("/export/my-data", { responseType: "blob" });
      const name =
        (res.headers["content-disposition"] || "").match(/filename="(.+?)"/)?.[1] ||
        "towhook-export.zip";
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = name;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Export downloaded");
    } catch (e) {
      toast.error(e?.response?.data?.detail?.msg || "Export failed — please try again");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="data-export-card"
      className="rounded-lg border bg-card p-5 shadow-sm"
    >
      <div className="flex items-center gap-2">
        <Download className="h-4 w-4 text-muted-foreground" />
        <h3 className="text-base font-semibold">Your data</h3>
      </div>
      <p className="mt-1 text-sm text-muted-foreground">
        Download everything on your account as a zip — jobs, history, trucks,
        staff and settings, with the main tables as spreadsheets you can open in
        Excel. Photo files themselves aren't included, only their records.
      </p>
      <Button
        data-testid="export-my-data-btn"
        className="mt-4"
        size="sm"
        disabled={busy}
        onClick={download}
      >
        {busy ? (
          <>
            <Loader2 className="mr-2 h-3 w-3 animate-spin" />
            Preparing…
          </>
        ) : (
          "Download my data"
        )}
      </Button>
    </div>
  );
};
